interface IFlashMessage {
  type: string;
  message: string;
  title: string;
}

declare var window: any;

const updateFlash = (props: IFlashMessage) => {
  const { type, message, title } = props;

  window.dispatchEvent(
    new CustomEvent("flash", {
      detail: { type: type, message: message, title: title },
    }),
  );
};

/*
Use for copying text to clipboard by a click of a button or link

You may use `data-copy-target` attribute to specify the target element to copy the text from.
Example:
  <textarea id={"text-container"} rows="9" disabled class="hidden">
    Text to copy
  </textarea>

  <button
    phx-hook="HandleCopyToClipBoard"
    id="some-id"
    data-copy-target={"text-container"}
    ...
  >
    Copy to clipboard
  </button>

Or use a class text-widget if you don't want to specify the target element.
Example:
  <textarea class="textarea-widget" rows="9" disabled class="hidden">
    Text to copy
  </textarea>

  <button
    phx-hook="HandleCopyToClipBoard"
    id="some-id"
    ...
  >
    Copy to clipboard
  </button>
*/
const HandleCopyToClipBoard = {
  copyTextNavigator(element: any) {
    const value = element.value;
    navigator.clipboard.writeText(value).then(
      () => {
        updateFlash({
          type: "success",
          message: "Copied to clipboard",
          title: "Success",
        });
      },
      (_err) => {
        updateFlash({
          type: "error",
          message: "Could not be copied to clipboard",
          title: "Sorry",
        });
      },
    );
  },
  copyTextDocument(element: any) {
    try {
      element.disabled = false;
      element.select();
      if (document.execCommand("copy")) {
        updateFlash({
          type: "success",
          message: "Copied to clipboard",
          title: "Success",
        });
      } else {
        updateFlash({
          type: "error",
          message: "Could not be copied to clipboard",
          title: "Sorry",
        });
      }
      element.disabled = true;
    } catch (err) {
      updateFlash({
        type: "error",
        message: "Could not be copied to clipboard",
        title: "Sorry",
      });
    }
  },
  copyTextFromElement(this: any, element: any) {
    if (!navigator.clipboard) {
      this.copyTextDocument(element);
    } else {
      this.copyTextNavigator(element);
    }
  },
  mounted(this: any) {
    this.el.addEventListener("click", (e: any) => {
      // stop propagation and prevent default so copy button can be placed inside links
      e.stopPropagation();
      e.preventDefault();

      const copyTarget = this.el.getAttribute("data-copy-target");
      let widgetTextarea = copyTarget
        ? document.getElementById(copyTarget)
        : document.querySelector(".textarea-widget");

      this.copyTextFromElement(widgetTextarea);
    });

    this.handleEvent("copy_to_clipboard", (data: any) => {
      let widgetTextarea = document.querySelector(data.copy_target);
      this.copyTextFromElement(widgetTextarea);
    });
  },
};

export default HandleCopyToClipBoard;
